import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import * as Sentry from '@sentry/react'
import GlobalStyle from './styles/Global'
import RootRouter from 'routers/Root'
import { signInWithToken } from 'actions/auth'
import { fetchBadges } from 'actions/badges'
import { getProfile } from 'actions/profile'
import { StaticLoader } from 'components/misc/Loader'
import Helmet from 'react-helmet'
import { useTheme } from 'styled-components/macro'
import { sendNativeMessage } from 'util/native'
import { isActive } from 'util/server/session'
import { is4xxError } from 'util/server/utils'
import CatchError from 'rui/widgets/CatchError'

const App = () => {
  const dispatch = useDispatch()
  const theme = useTheme()
  const [ready, setReady] = useState(false)
  const [hash, setHash] = useState(undefined)

  useEffect(() => {
    // TODO could this be refactored to use lazy/Suspense?
    dispatch(fetchBadges())

    const query = new URLSearchParams(window.location.search)
    const token = query.get('token')
    const ephemeral = query.get('ephemeral')
    const startHash = window.location.hash ? window.location.hash.substring(1) : ''

    const finish = () => {
      setHash(startHash)
      setReady(true)
    }

    if (token) {
      console.log('Logging in with token', new Date())
      dispatch(signInWithToken(token, ephemeral)).then(
        () => {
          sendNativeMessage({ type: 'AUTH_READY' })
          finish()
        },
        (err) => {
          const status = err?.response?.rawResponse?.status
          console.log('Logging in with token failed', new Date(), err)
          if (!is4xxError(status)) {
            Sentry.captureException(err, {
              level: 'error',
              tags: { error_type: 'token_sign_in_error' },
              extra: { status, errorMessage: err?.message },
            })
          }
          sendNativeMessage({ type: 'AUTH_FAILED' })
          finish()
        }
      )
    } else if (isActive()) {
      console.log('session is live, fetching profile.')
      dispatch(getProfile()).then(finish)
    } else {
      console.log('no token - no session')
      finish()
    }
  }, [dispatch])

  const AppContents = ready ? RootRouter : StaticLoader

  return (
    <>
      <Helmet>
        <link rel="shortcut icon" href={`${import.meta.env.REACT_APP_THEME_BUCKET}/roadie/${theme.favicon}`}></link>
      </Helmet>
      <GlobalStyle />
      <CatchError>
        <AppContents startRoute={hash} />
      </CatchError>
    </>
  )
}

export default App
